import { SET_CARDETAIL } from '../actions';

const cardetail = (state = [], action) => {
  switch (action.type) {
	case SET_CARDETAIL:
      return [...action.value];  
    default: return state;
  }
}

export default cardetail;
